import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import {Modal} from "react-bootstrap";

let source = axios.CancelToken.source();

class Allocate_allocate_vehicle_v2 extends Component {
    constructor() {
        super();
        this.state = {
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            fright: false,
            frightno: "",
            assignment:null,

            openorder: false,
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            txtsearch_order: '',
            allocation_id: '',

            assignshow:false,
            wizard:0,
        }
    }

    async componentDidMount() {
        this.get_vehicle_for_allocation();
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    inputmgt_fitler = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
        if (this.state.vehsorginall) {
            let temp = this.state.vehsorginal.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                vehs: temp,
            })
        }
    }
    get_vehicle_for_allocation = () => {
        let baseurl = myconfig.get_vehicle_for_allocation;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            fright: false,
            frightno: "",
            assignment:null,

            openorder: false,
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            txtsearch_order: '',
            allocation_id: '',

            assignshow:false,
            wizard:0,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehs: res.data.datas,
                    vehsorginal: res.data,
                    vehsorginall: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    modalfright = () => {
        return (<Modal
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.fright}
                onHide={this.hidefright}>
                <Modal.Header><h4>Fright #</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Fright Management</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Fright #</label>
                                                    <input className="form-control" type="text" name="frightno"
                                                           onChange={this.inputmgt} value={this.state.frightno}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary"
                                                onClick={this.submitfright}>Next
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    showfright = (event, assignment) => {
        event.preventDefault()
        this.setState({
            fright: true,
            fright_no: '',
            assignment:assignment,
        })
    }
    hidefright = () => {
        this.setState({
            fright: false,
        })
    }
    submitfright = (event) => {
        event.preventDefault()
        let baseurl = myconfig.check_fright_no;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            fright_no: this.state.frightno,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.showopenorder();
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    modalopenorder = () => {
        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.openorder}
                onHide={this.hideopenorder}>
                <Modal.Header><h4>Open Order's</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="card-tools">
                                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                                            <input type="text" name="txtsearch_order"
                                                   onChange={this.inputmgt_fitler_openorder}
                                                   className="form-control float-right"
                                                   value={this.state.txtsearch_order} placeholder="Search"/>
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-default">
                                                    <i className="fas fa-search"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Action</th>
                                            <th>Order Date</th>
                                            <th>Order #</th>
                                            <th>Company Name</th>
                                            <th>Cargo Name</th>
                                            <th>Volume</th>
                                            <th>Sale Type</th>
                                            <th>Type</th>
                                            <th>Transport Rate</th>
                                            <th>Cement Rate</th>
                                            <th>Cement Cost</th>
                                            <th>Start Date</th>
                                            <th>Closed Date</th>
                                            <th>Org</th>
                                            <th>Des</th>
                                            <th>Total</th>
                                            <th>Assigned</th>
                                            <th>Not-assigned</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.tabledataopenorder()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    showopenorder = () => {
        this.setState({
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            openorder: false,
        })
        let baseurl = myconfig.get_open_order_status_for_allocation;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    openordersorginal: res.data,
                    openordersorginall: true,
                    orders: res.data.datas,
                    openorder: true,
                    fright: false,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    hideopenorder = () => {
        this.setState({
            openorder: false,
        })
    }
    submitopenorder = (event, order_id) => {
        event.preventDefault()
        let baseurl = myconfig.get_allocation_id_for;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: order_id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                if (res.data.allocation_id == null) {
                    Swal.fire({
                        title: 'Error!',
                        text: "No allocation found for vehicle to be allocated",
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        allocation_id: res.data.allocation_id,
                        openorder: false,
                    },()=>this.wizard_1_btn())
                }
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    inputmgt_fitler_openorder = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
        if (this.state.openordersorginall) {
            let temp = this.state.openordersorginal.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.companyname.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                orders: temp,
            })
        }
    }
    tabledataopenorder = () => {
        let count = 0;
        let retdata = this.state.orders.map(value => {
            count = count + 1
            return (<tr>
                <td>{count}</td>
                <td><a href="{#}" onClick={(event => this.submitopenorder(event, value.id))}>Select</a>
                </td>
                <td>{value.orderdate}</td>
                <td>{value.order_no}</td>
                <td>{value.companyname}</td>
                <td>{value.cargo_name}</td>
                <td>{value.volume}</td>
                <td>{value.sale_type}</td>
                <td>{value.type}</td>
                <td>{value.transport_rate_q}</td>
                <td>{value.cement_rate_q}</td>
                <td>{value.cement_cost}</td>
                <td>{value.stdate}</td>
                <td>{value.eddate}</td>
                <td>{value.rr_loc_org}</td>
                <td>{value.rr_loc_des}</td>
                <td>{value.total_count}</td>
                <td>{value.assigned_count}</td>
                <td>{value.not_assigned}</td>
            </tr>)
        })
        return (<>{retdata}</>)
    }

    hideassign = () => {
        this.setState({
            assignshow: false,
        })
    }
    modalassign=()=> {
        let display=null;
        let size="md";
        if(this.state.wizard==2)
            display=this.wizard_2()
        else if(this.state.wizard==3)
            display=this.wizard_3()
        else if(this.state.wizard==4)
            display=this.wizard_4()
        return (<Modal
                size={size}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.assignshow}
                onHide={this.hideassign}>
                <Modal.Header><h4>Vehicle Assigment</h4>
                    <small>({this.state.msg})</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            {display}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }

    wizard_1_btn = () => {
        console.log(this.state.assignment)
        console.log("afsdsdfasdfasadfsadfsdfasdfasdfasdfa")
        if (this.state.assignment.status == "WAITING_FOR_ORDER") {
            let baseurl = myconfig.vehicle_allocation;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
                "sid":window.localStorage.getItem("ntfms_sid"),
                "allocation_id": this.state.allocation_id,
                "assignment_id":this.state.assignment.id,
                "frightno": this.state.frightno,
                "wiz_algo": 1,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.get_vehicle_for_allocation()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(this.state.assignment.status=="HEADING_TO_STATION"){
            this.setState({
                wizard:2,
                assignshow: true,
            })
        }
    }
    wizard_2=()=>{
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-search" /> Type of trip select
                    </h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,3))} className="form-control btn btn-success">
                                    From GPS
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,1))} className="form-control btn btn-dark">
                                    Same as Orgin
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,2))} className="form-control btn btn-dark">
                                    From Route Master
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" className="form-control btn btn-info">
                                    Others
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" className="form-control btn btn-danger">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="text-muted mt-3">
                        For more information look at <a href="#">apps.ztsus.com</a>
                    </div>
                </div>
            </div>
        </>)
    }
    wizard_2_btn = (event,type) => {
        //type 1 for Same as load
        //type 2 for from load point
        event.preventDefault();
        if(type==1){
            let baseurl = myconfig.vehicle_allocation;
            let redirecttologin = myconfig.redirecttologin;
            let value = this.state.assignment;
            axios.post(baseurl, {
                "sid":window.localStorage.getItem("ntfms_sid"),
                "allocation_id": this.state.allocation_id,
                "assignment_id":value.id,
                "frightno": this.state.frightno,
                "wiz_algo": 2,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.get_vehicle_for_allocation()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(type==2){
            let baseurl = myconfig.getlocations;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        locations:res.data.datas,
                        locationload:true,
                        locationselected:"-1",
                        wizard:3,
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(type==3){
            this.setState({
                wizard:4,
            })
        }
    }
    wizard_3=()=>{
        let dataoption=null;
        if(this.state.locationload){
            dataoption=this.state.locations.map(value => {
                return (<option value={value.id}>{value.loc_full_name}</option>)
            })
        }
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-book" /> From Route Master
                    </h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Route Orgin</label>
                                    <select name="locationselected" value={this.state.locationselected} className="form-control" onChange={this.inputmgt}>
                                        <option value="-1">-- Select Location --</option>
                                        {dataoption}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <button type="submit" className="btn btn-primary" onClick={this.wizard_3_btn}>Select</button>
                </div>
            </div>
        </>)
    }
    wizard_3_btn = (event) => {
        event.preventDefault()
        let baseurl = myconfig.vehicle_allocation;
        let redirecttologin = myconfig.redirecttologin;
        let value = this.state.assignment;
        axios.post(baseurl, {
            "sid":window.localStorage.getItem("ntfms_sid"),
            "allocation_id": this.state.allocation_id,
            "assignment_id":value.id,
            "frightno": this.state.frightno,
            "locationselected":this.state.locationselected,
            "wiz_algo": 3,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Success!',
                    text: "Vehicle select successfully",
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(value => {
                    this.get_vehicle_for_allocation()
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    wizard_4=()=>{
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-gears" /> From GPS Data
                    </h3>
                </div>
                <div className="card-body">
                    <form>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Location</label>
                                    <input name="cur_location" value={this.state.cur_location} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Coordinate</label>
                                    <input  name="cur_cor" value={this.state.cur_cor} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Update Time</label>
                                    <input disabled name="cur_avl" value={this.state.cur_avl} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Distance</label>
                                    <input  name="cur_distance" value={this.state.cur_distance} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Location Short Name</label>
                                    <input  name="cur_short_name" value={this.state.cur_short_name} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Fuel Empty</label>
                                    <input  name="cur_fuel_empty" value={this.state.cur_fuel_empty} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Handling Fee Empty</label>
                                    <input  name="cur_handling_fee" value={this.state.cur_handling_fee} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="card-footer d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary" onClick={this.wizard_4_btn}>Submit</button>
                    <button type="submit" className="btn btn-primary" onClick={this.getfromgps}>From GPS</button>
                    <button type="submit" className="btn btn-primary" onClick={this.getfromcor}>From Coordinate</button>
                </div>
            </div>
        </>)
    }
    wizard_4_btn = (event) => {
        event.preventDefault()
        if (this.state.cur_location == "") {
            Swal.fire({
                title: 'Error!',
                text: "Please enter location",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_cor == "") {
            Swal.fire({
                title: 'Error!',
                text: "Please enter location coordinate",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_distance == "" || isNaN(this.state.cur_distance)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter distance",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_distance < 0) {
            Swal.fire({
                title: 'Error!',
                text: "Distance must be equal to zero or above",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_fuel_empty == "" || isNaN(this.state.cur_fuel_empty)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter fuel empty",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_fuel_empty <= 0) {
            Swal.fire({
                title: 'Error!',
                text: "Fuel empty can not be zero and below",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_handling_fee == "" || isNaN(this.state.cur_handling_fee)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter handling fee empty",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_handling_fee < 0) {
            Swal.fire({
                title: 'Error!',
                text: "Handling fee must be equal to zero or above",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else {
            let cur_distance=parseFloat(this.state.cur_distance);
            let cur_fuel_empty=parseFloat(this.state.cur_fuel_empty);
            let cur_fule_qty_empty=parseFloat(cur_distance/cur_fuel_empty).toFixed(2)
            let cur_perdiem_empty=parseFloat(cur_distance*4.33*0.25).toFixed(2)
            let cur_handling_fee=parseFloat(this.state.cur_handling_fee);
            let baseurl = myconfig.vehicle_allocation;
            let redirecttologin = myconfig.redirecttologin;
            let value = this.state.value;
            axios.post(baseurl, {
                "sid":window.localStorage.getItem("ntfms_sid"),
                "allocation_id": this.state.allocation_id,
                "assignment_id":value.id,
                "frightno": this.state.frightno,
                "wiz_algo": 4,
                "cur_location": this.state.cur_location,
                "cur_cor": this.state.cur_cor,
                "cur_short_name": this.state.cur_short_name,
                "cur_distance": cur_distance,
                "cur_fuel_empty": cur_fuel_empty,
                "cur_fule_qty_empty": cur_fule_qty_empty,
                "cur_perdiem_empty": cur_perdiem_empty,
                "cur_handling_fee": cur_handling_fee,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.get_vehicle_for_allocation()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }
    getfromgps = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyfromgps;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        console.log(this.state.value)
        axios.post(baseurl, {
            allocate_id:this.state.allocation_id,
            truck_id:this.state.value.truck_id,
            sid:sid,
            user:user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cur_distance:res.data.data.cur_distance,
                    cur_location:res.data.data.cur_location,
                    cur_cor:res.data.data.cur_cor,
                    cur_avl:res.data.data.cur_avl,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    getfromcor = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyfromcor;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        axios.post(baseurl, {
            allocate_id:allocate_id,
            truck_id:this.state.value.truck_id,
            sid:sid,
            user:user,
            cur_cor:this.state.cur_cor,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cur_distance:res.data.data.cur_distance,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    assignvehicle = (event,id) => {
        event.preventDefault()
        let baseurl = myconfig.getavavehicles;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehicles:res.data.datas,
                    vehicleload:true,
                    assignshow:true,
                    wizard:1,
                    allocation_id:id,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }



    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    tabledata = () => {
        let count = 0;
        let retdata = this.state.vehs.map(value => {
            count = count + 1
            return (<tr>
                <td>{count}</td>
                <td>
                    <a href="#" onClick={(event) => this.showfright(event, value)}>Assign</a>
                </td>
                <td>{value.plate_no}</td>
                <td>{value.status}</td>
                <td>{value.dri_name}</td>
                <td>{value.dri_phoneno}</td>
                <td>{value.tra_plateno}</td>
                <td>{value.orderdate}</td>
                <td>{value.volume}</td>
                <td>{value.sale_type}</td>
                <td>{value.org}</td>
                <td>{value.des}</td>
                <td>{value.cargo_id}</td>
                <td>{value.customer_id}</td>
                <td>{value.dateofoffloading}</td>
            </tr>)
        })
        return (<>{retdata}</>)
    }

    render() {
        return (
            <>
                <Nav type="allocate_allocate_vehicle_v2"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Allocation V2</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Allocation V2</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtsearch" onChange={this.inputmgt_fitler}
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Action</th>
                                                <th>Truck</th>
                                                <th>Status</th>
                                                <th>Driver</th>
                                                <th>Contact</th>
                                                <th>Trailer</th>
                                                <th>(prv) Order Date</th>
                                                <th>(prv) Volume</th>
                                                <th>(prv) Sale_type</th>
                                                <th>(prv) Org</th>
                                                <th>(prv) Des</th>
                                                <th>(prv) Cargo</th>
                                                <th>(prv) Customer</th>
                                                <th>(prv) Offloading</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalfright()}
                {this.modalopenorder()}
                {this.modalassign()}
            </>
        )
    }
}

export default Allocate_allocate_vehicle_v2;
